const tournaments = {
    "LBL_PAGE_TITLE":"Turnee",
    "LBL_POPUP_ERROR":"Eroare",
    "LBL_USERNAME_FORM_FIELD_NAME":"Crează-ți un nume de utilizator:",
    "LBL_USERNAME_FORM_HELPER":"Dvs pentru prima dată intrați pe zona de joc, este necesar să creați un nume de utilizator",
    "LBL_USERNAME_FORM_FIELD":"Nume de utilizator",
    "LBL_FORM_LOGIN_BUTTON":"Intrarea în zona de joc",
    "LBL_TYPE_BULLET":"Bullet",
    "LBL_TYPE_BLITZ":"Blitz",
    "LBL_TYPE_RAPID":"Rapid",
    "LBL_TYPE_CLASSIC":"Classic",
    "LBL_INITIAL_RATING":"Fără Restricții"
};
export default tournaments;